<template>
  <v-container>
    <div class="page">
      <div v-for="(item, index) in history" :key="index">
        <div class="item">
          <div class="d-flex">
            <v-list-item-icon class="d-flex circle">
              <v-icon color="#94070A" class="icon-right" >mdi-circle-medium</v-icon>
            </v-list-item-icon>
            <strong class="me-4">{{item.date}}</strong>
            <div>
              <span> {{item.description}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      history: [{
        date: '2023.01.01',
        description: 'First release of ExposomeX platform including both versions of web interface (v1.0.0) and R package (v1.0.0) for peer testing.'
      },{
        date: '2024.07.01',
        description: 'Second release of ExposomeX platform including both versions of web interface (v1.0.1) and R package (v1.0.1) for peer testing.'
      },{
        date: '2025.11.11',
        description: 'Third release of ExposomeX platform including both versions of web interface (v1.0.2) for peer testing.'
      },{
        date: '2025.12.01',
        description: 'Release the E-BIO (v1.0.2) for peer testing.'
      },{
        date: '2026.02.01',
        description: 'Release the E-DB (v1.0.2)  for peer testing.'
      }
    ]
    };
  },
  methods: {
  },
};
</script>
<style scoped lang="scss">
.page {
  font-size: $webpage-base-font-size;
  margin-top: 1em;
}
.circle {
  padding-right: 0.4em;
}
.item {
  margin-bottom: 1em;
}
</style>
